import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader } from 'shards-react';
import VChart from './VChart';

const retentionChartOptions = {
  responsive: true,
  scales: {
    yAxes: [
      {
        ticks: {
          min: 0,
          max: 100,
          callback(value) {
            return `${value}%`;
          },
        },
      },
    ],
  },
  tooltips: {
    mode: 'index',
    intersect: false,
  },
};

const RetentionOverview = ({ retention, title }) => {
  const { datasets, labels } = useMemo(() => ({
    labels: retention.map(item => item.period),
    datasets: [
      {
        label: 'Retention Rate',
        data: retention.map(item => item.retentionRate),
        color: '#007bff',
      },
      {
        label: 'Churn Rate',
        data: retention.map(item => item.churnRate),
        color: '#ff4169',
        borderDash: [3, 3],
      },
    ],
  }), [retention]);

  return (
    <Card small className="h-100">
      <CardHeader className="border-bottom">
        <h6 className="m-0">{title}</h6>
      </CardHeader>
      <CardBody className="pt-0">
        {retention.length > 0
          ? (
            <VChart
              labels={labels}
              datasets={datasets}
              type="line"
              chartOptions={retentionChartOptions}
            />
          )
          : <div className="text-center text-muted p-4">No retention data in this range</div>}
      </CardBody>
    </Card>
  );
};

RetentionOverview.propTypes = {
  retention: PropTypes.array,
  title: PropTypes.string,
};

RetentionOverview.defaultProps = {
  retention: [],
  title: 'Users Retention Rate',
};

export default RetentionOverview;
